<!-- 操作日志 -->
<template>
  <div>
    <finance-drawer
      title="操作日志"
      width="40%"
      v-bind="$attrs"
      v-on="$listeners"
      :modal-close="false"
      :isRefresh="false"
      @open="handleOpen"
    >
      <div v-loading="loading">
        <el-steps direction="vertical" :active="1" :space="10">
          <el-step v-for="(item, index) in list" :key="index" status="process">
            <template #title>
              <div class="step-title">
                <div>订单金额修改</div>
                <div>{{ item.operateTime | formatTime}}</div>
              </div>
            </template>
            <template #description>
              <data-show label="修改前：">{{ item.amount | toFenThousandsAndFloat('¥') }}</data-show>
              <data-show label="修改后：">{{ item.newAmount | toFenThousandsAndFloat('¥') }}</data-show>
              <data-show label="单号：">{{ item.applyNo || '-' }}</data-show>
            </template>
          </el-step>
        </el-steps>
      </div>
    </finance-drawer>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    // 打开窗口前
    handleOpen() {
      this.$nextTick(() => {
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .el-steps {
    .el-step__icon-inner {
      display: none;
    }
    .el-step__description.is-process {
      padding-bottom: 20px;
    }
  }
  .el-step.is-vertical .el-step__title {
    font-weight: 700;
    color: #303133;
  }
}

.step-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
